<template>
    <div class="right-panel">
        <div class="row">
            <div class="col">
                <h4>Coordinators</h4>    
            </div>
            <!-- <div class="col text-right">
                <button class="btn btn-primary" @click="onAddClick">Create New Deliverer</button>
            </div> -->
        </div>
    </div>
</template>
    
<script setup lang="ts">
</script>

<style scoped></style>